import { session1 } from './session1';
import { session2 } from './session2';
import { session3 } from './session3';
import { session4 } from './session4';
import { session5 } from './session5';
import { session6 } from './session6';
import { session7 } from './session7';
import { session8 } from './session8';
import { session9 } from './session9';
import { session10 } from './session10';
import { completion } from './completion.js';

export const microprocessor = {
    id: "microprocessor",
    title: "Microprocessor from Scratch",
    description: "Master processor architecture, instruction sets, and modern computing technologies",
    color: "#4A90E2",
    icon: "🖥️",
    level: "Intermediate",
    duration: "8 hours",
    students: "1,250",
    sessions: [
        session1,
        session2,
        session3,
        session4,
        session5,
        session6,
        session7,
        session8,
        session9,
        session10,
        completion
    ]
};
